import prdConfig from './prd'
import devCofig from './dev'
let config = ''
switch (process.env.NODE_ENV) {
    case 'development':
        config = devCofig
        break
    default:
        config = prdConfig
}
export default config
